import { useEffect } from 'react';
import { useGetCtaWrapperContent } from '@/vdp/CtaWrapper';
import { useScrollDetection } from '@/vdp/CtaWrapper/hooks/useScrollDetection';
import { VdpDispatcherEvent } from './constants';
import sendMessageToNative from './sendMessageToNative';

/**
 * Signals native to hide the SEBS chat icon while the blue "no longer available" CTA footer is shown
 * (and the user is at the top of the page), so it does not obstruct the footer text. Mirrors the web
 * chat bubble's scroll-coupled behavior in useChatBubblePositioning. No-ops on web.
 *
 * Fires on mount (plain useEffect, not useSubsequentEffect) so the icon is hidden on first landing:
 * for PIP/sold vehicles showCtaFooter is already true on the initial render, so a mount-skipping effect
 * would never send the first hide. The redundant show:true on a normal available vehicle is harmless
 * and idempotent.
 *
 * The payload includes both `show` (iOS contract, MOB-28333) and `shouldShow` (Android contract,
 * MOB-28335) since the two native contracts use different keys for the same boolean.
 */
export default function useToggleChatDispatcher(): void {
  const { showCtaFooter } = useGetCtaWrapperContent();
  const hasScrolled = useScrollDetection();
  const isFooterAtTop = showCtaFooter && !hasScrolled;
  const shouldShowChat = !isFooterAtTop;

  useEffect(() => {
    sendMessageToNative(VdpDispatcherEvent.ToggleChatUi, {
      show: shouldShowChat,
      shouldShow: shouldShowChat
    });
  }, [shouldShowChat]);
}
